import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { HOUSES_POPULATION_LEGEND, HOUSES_YEAR_LEGEND } from '../../../constants/legends';

const HousesPopLegendComponent = () => (
    <div>
        <LegendRenderer config={HOUSES_POPULATION_LEGEND} />
        <LegendRenderer config={HOUSES_YEAR_LEGEND} />
    </div>
);

export const HousesLegend = withDisplayedLayersCheck(HousesPopLegendComponent, t`Жилые дома`);
